let current=null;
export function stopAssistantPlayback(){const stop=current;current=null;stop?.();window.speechSynthesis?.cancel();}
export function ownAssistantPlayback(stop){stopAssistantPlayback();current=stop;return()=>{if(current===stop)current=null;};}
